<template>
    <b-modal
        id="modalUploadProgress"
        ref="uploadModalProgress"
        title="アップロード状況"
        size="lg"
        @shown="modalOpen"
    >
        <div style="max-height: 600px; overflow-y: auto">
            <b-list-group>
                <b-list-group-item
                    v-for="upload in uploads"
                    :key="upload.id"
                >
                    {{ upload.name }}<br>
                    <b-progress>
                        <b-progress-bar
                            :value="upload.progress"
                            :label="upload.progress + '%'"
                            show-progress
                            :animated="upload.uploading"
                            :variant="upload.error ? 'danger': (upload.uploaded ? 'success':'primary')"
                        />
                    </b-progress>
                    <small
                        v-if="upload.error"
                        class="text-muted"
                    >{{ upload.msg }}</small>
                </b-list-group-item>
            </b-list-group>
        </div>
        <div
            slot="modal-footer"
            class="w-100"
        >
            <span class="float-left m-0">
                <!--<b-btn @click.prevent="start" variant="primary" v-if="!uploadGroup.uploading && !uploadGroup.uploaded && !uploadGroup.error" class="float-left">開始</b-btn>-->
                <b-btn
                    v-if="uploadGroup.uploading"
                    variant="danger"
                    class="float-left"
                    @click.prevent="stopUpload"
                >停止</b-btn>
            </span>
            <span class="float-right m-0">
                <b-btn
                    v-if="uploadGroup.error"
                    variant="primary"
                    class="float-right"
                    @click.prevent="retry"
                >リトライ</b-btn>
            </span>
        </div>
    </b-modal>
</template>

<script>
import { mapState } from 'pinia'
import { store } from '@/store.js'

export default {
    name: 'UploadProgressModal',
    data () {
        return {
            idx: -1
        }
    },
    computed: {
        ...mapState(store, ['uploadGroups']),
        uploads () {
            if (this.idx > -1) {
                if (this.idx < this.uploadGroups.length) {
                    return this.uploadGroups[this.idx].uploads
                }
            }
            return []
        },
        uploadGroup () {
            if (this.idx > -1) {
                if (this.idx < this.uploadGroups.length) {
                    return this.uploadGroups[this.idx]
                }
            }
            return {}
        }
    },
    mounted () {
        this.$root.$on('openUploadProgressModal', (idx) => {
            this.idx = idx
            if (this.$refs.uploadModalProgress) {
                this.$refs.uploadModalProgress.show()
            }
        })
    },
    methods: {
        start () {
            if (this.uploadGroups.filter((v) => v.uploading).length < 2) {
                this.$root.emit('')
                this.$parent.startUploadGroup(this.idx)
            } else {
                this.$snotify.error('すでに２つのアップロードが行わている')
            }
        },
        retry () {
            this.$parent.startUploadGroup(this.idx)
        },
        stopUpload () {
            this.$parent.cancelUpload(this.idx, ' ユーザによって停止された')
        },
        modalOpen () {
            // TODO
        }
    }
}
</script>

<style scoped>

</style>
